import service from '../../utils/request';
import axios from 'axios';

type ApiResult<T> = { payload: T; status: number; errors?: Array<any> };

// Thin axios wrapper to keep a unified call shape across API modules
export async function getJson<T>(url: string, params?: Record<string, any>, signal?: AbortSignal): Promise<T> {
  // Map AbortSignal to Axios CancelToken for compatibility
  let cancelToken: any | undefined;
  if (signal) {
    const source = axios.CancelToken.source();
    cancelToken = source.token;
    if (signal.aborted) {
      source.cancel('aborted');
    } else {
      signal.addEventListener('abort', () => source.cancel('aborted'));
    }
  }
  const resp = await service.get(url, {
    params,
    cancelToken,
  });
  // Axios already throws for non-2xx via interceptors/errorHandling
  // Unwrap our standard Result<T> envelope when present; otherwise return raw data
  const data = resp.data as any;
  if (data && typeof data === 'object' && 'payload' in data && 'status' in data) {
    return (data as ApiResult<T>).payload as T;
  }
  return data as T;
}
